import { loginApi, userLoginSuccess } from "@/core/api/user_api";

export default async function authorize(login: string, password: string): Promise<userLoginSuccess> {
    return (await loginApi(login, password));
}